class FeedCalcSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    // Only show products that have a valid value in metafield calories per gram
    this.productsRaw = JSON.parse(document.querySelector('#products-for-feed-calc-search').innerHTML);
    this.products = this.productsRaw.filter(p => p.metafield !== "0");
  
    this.FeedCalcSearchResults = this.querySelector(".all-search-results");

    this.searchButton = this.querySelector(".feed-calc-button");

    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.setupEventListeners();

    
    const searchResultsElement = this.querySelector(".all-search-results");
    if (searchResultsElement) {
      searchResultsElement.style.display = "none";
    }

    this.productLinks = this.querySelector(".feed-calc-search__item--link");
  }

  setupEventListeners() {
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.searchButton.addEventListener('click', this.onChange.bind(this));
  }

  decodeHtmlEntities(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc.documentElement.textContent;
  }

  // Round to the closest quarter (0, 0.25, 0.5, 0.75, 1)
  getStarClass(rating) {
    const roundedRating = Math.floor(rating * 4) / 4;
    let starClass = "";
    switch (roundedRating) {
        case 0:
            starClass = "stars__icon--0";
            break;
        case 0.25:
            starClass = "stars__icon--25";
            break;
        case 0.5:
            starClass = "stars__icon--50";
            break;
        case 0.75:
            starClass = "stars__icon--75";
            break;
        case 1:
            starClass = "stars__icon--100";
            break;
        default:
            starClass = "stars__icon--0";
    }

    return starClass;
  }

  // open product card on the right side
  onProductClick(event) {
    const productId = event.target.closest('.feed-calc-search__item--link').getAttribute("data-product-id");
    const product = this.products.find(product => product.id == productId);
    const chosen_product_id = product ? product.id : null;
    if(!product)
      return;

    this.enableLoading();

    const productCart = `<div class="product-card product-card--card-layout btn-quickview-hover image-hover-scaling-up position-relative hover-area product-card--vertical">
    <div id="badge__container-template--24618499440979__feed_calculator_bGxqKa" class="badge__container badge--fixed"></div>
    <div class="product-card__image-holder mb15">
      <a href="" target="_blank" class="product-card__image image-hover-scaling__image border__radius " style="--aspect-ratio: 1;" 1="">
        <img srcset="" height="1200" alt="" loading="lazy" class="image-show--fadein image-loaded" onload="this.classList.add('image-loaded');">
      </a>
    </div>
<div class="product-card__container mt--first-child-0">
  <div class="mt5 before-rating-snippet">
    <a href="" target="_blank" class="product-card__heading"></a>
  </div>
  <div class="mt10 custom--rating-snippet"
    data-widget-id="HlMLprUNBC3dVGI0" >
    <div class="RatingSnippetWidget__inner">
      <div class="RatingSnippetWidget__content">
        <div class="RatingSnippetWidget__stars">
          <div class="R-RatingStars">
            <div class="R-RatingStars__stars u-marginBottom--none u-marginRight--none">
              <i class="stars__icon ricon-percentage-star--100" aria-hidden="true"></i>
              <i class="stars__icon ricon-percentage-star--100" aria-hidden="true"></i>
              <i class="stars__icon ricon-percentage-star--100" aria-hidden="true"></i>
              <i class="stars__icon ricon-percentage-star--100" aria-hidden="true"></i>
              <i class="stars__icon ricon-percentage-star--100" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div class="RatingSnippetWidget__text">
          <div class="RatingSnippetWidget__score">
            <div class="R-TextBody R-TextBody--xs u-marginBottom--none">
              <div class="cssVar-ratingText"></div>
            </div>
          </div>
          <div class="RatingSnippetWidget__count">
            <div class="R-TextBody R-TextBody--xs u-marginBottom--none"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
      <!-- Custom Metafield "produktbeschreibung" -->
      <div class="produktbeschreibung">
        <p class="product-card-produktbeschreibung-vertical"></p>
      </div>
      <div class="price-wrapper price-wrapper-inline">
        <div class="price mt5"> 
          <div class="price__normal h5"></div>
        </div>
        <div class="unit-price body3">
          <span class="unit-product-price"></span>
          <span aria-hidden="true">/</span>
          <span class="visually-hidden">&nbsp;pro&nbsp;</span>
          <span>kg</span>
        </div>
      </div>
      <a class="link-to-product" href="" class="btn mt10" target="_blank">Zum Produkt</a>
    </div>
</div>`

    let cloned = new DOMParser().parseFromString(productCart, 'text/html').body.firstChild;

    if(cloned){
      cloned.setAttribute("data-product-id", chosen_product_id);

      cloned.querySelector(".product-card__image-holder a").setAttribute("href", product.url);
      cloned.querySelector(".product-card__image img").setAttribute("srcset", product.featured_media);
      cloned.querySelector(".product-card__image img").setAttribute("alt", product.title);
      cloned.querySelector(".product-card__image").setAttribute("href", product.url);

      cloned.querySelector(".product-card__heading").innerHTML = product.title;
      cloned.querySelector(".product-card__heading").setAttribute("href", product.url);

      const container = cloned.querySelector(".product-card-produktbeschreibung-vertical");

      const description = product.description.split("\n");
      description.forEach(line =>{
        if(line.trim() !== ""){
          const span = document.createElement("span");
          span.textContent = this.decodeHtmlEntities(line);
          if(container) container.appendChild(span);
        }
      })

      cloned.querySelector(".price-wrapper .price__normal").innerHTML = "Ab " + product.price;
      cloned.querySelector(".unit-price .unit-product-price").innerHTML = "Ab " + product.unit_price;
      cloned.querySelector(".link-to-product").setAttribute("href", product.url);
      if(product.rating_total && product.rating_average){
        let average = Number(product.rating_average);
  
        cloned.querySelector(".cssVar-ratingText").innerHTML = average.toFixed(1);
        cloned.querySelector(".RatingSnippetWidget__count .R-TextBody--xs").innerHTML = "(" + product.rating_total + ")";
  
        const stars = cloned.querySelectorAll(".R-RatingStars__stars .stars__icon");
  
        for (let index = 0; index < stars.length; index++) {
          const element = stars[index];
  
          if(index+1 <= product.rating_average){
            element.classList.add("stars__icon--100");
          } else if(index+1 >  product.rating_average && index+1 === Math.ceil(product.rating_average)){
            element.classList.add(this.getStarClass(product.rating_average - index));
          } else {
            element.classList.add("stars__icon--0");
          }
          
        }
      }
    }

    const parent = document.querySelector("#feed-calc-product-card");
    if(parent){
      const existingCard = document.querySelector("#feed-calc-product-card .product-card");
      if(existingCard){
        parent.removeChild(existingCard);
      }
      parent.appendChild(cloned);
    }

      const infopopup = document.querySelector(".feed-calculator-all-container .information-popup-mobile-container");
      if(infopopup){
        infopopup.style.display = "none";
      }

      this.isOpen = false;
      this.close();
      this.disableLoading();
  }

  // handle spinner for product card loading
  enableLoading() {
    const spinner = document.querySelector(".feed-calc-product-search .feed-calc-product-card-loading");
    if(spinner) {
      spinner.classList.remove("visually-hidden");
    }
  }

  disableLoading() {
    const spinner = document.querySelector(".feed-calc-product-search .feed-calc-product-card-loading");
    if(spinner) {
      spinner.classList.add("visually-hidden");
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    this.searchTerm = this.getQuery();
    this.close();
    this.getSearchResults(this.searchTerm);
  }

  onFocus() {
    const infopopup = document.querySelector(".feed-calculator-all-container .information-popup-mobile-container");
    if(infopopup){
      infopopup.style.display = "block";
    }
    const currentSearchTerm = this.getQuery();
    if ((this.searchTerm !== currentSearchTerm) || !currentSearchTerm.length) {
      this.onChange();
    } else {
      this.close();
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    const infopopup = document.querySelector(".feed-calculator-all-container .information-popup-mobile-container");
    setTimeout(() => {
      document.body.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          if (!infopopup.contains(event.target) && !event.target.closest(".popup-button")){
            if(infopopup){
              infopopup.style.display = "none";
            }
            this.close();
          }
        }
      })
    });
  }

  getSearchResults(searchTerm) {
    searchTerm.replace(" ", "-").toLowerCase();
    
    let filtered = this.products.filter(product => product.title.toLowerCase().includes(searchTerm.toLowerCase()));
    const noProductsInfo = this.querySelector(".no-products-found");

    if(filtered.length === 0){
      // no products found
      noProductsInfo.classList.remove('hidden');
      this.open();
    } else {
      // products found, render
      noProductsInfo.classList.add('hidden');
      this.renderSearchResults(filtered);
    }
  }

  renderSearchResults(resultsMarkup) {
    const renderElement = `<div class="searchResults predictive predictive--search-template" tabindex="-1">
      <ul class="predictive-search__results-list unstyle-ul" role="listbox" aria-labelledby="predictive-search-products">
          <li  class="predictive-search__list-item" role="option" aria-selected="false">
          <a class="predictive-search__item feed-calc-search__item--link predictive-search__item--link image-hover-scaling-up" tabindex="-1"><div class="image-hover-scaling__image">
              <div class="border__radius feed-calc-img-container">
                  <img class="feed-calc-search__image predictive-search__image" src="" alt="" width="50" height="50.0">
              </div>                  
              </div><div class="predictive-search__item-content body2"><p class="feed-calc-search__item-heading predictive-search__item-heading"><span class="feed-calc-search__item_link">HEADING HERE</span></p>
              <div class="price-wrapper feed-calc-price-wrapper">
                  <div class="price mt5"> 
                      <div class="feed-calc-price__normal predictive-price__normal h5"></div>
                      </div>
                      <div class="unit-price body3"><span>Ab <span class="feed-calc-unit-price predictive-unit-price"></span></span><span aria-hidden="true">/</span><span class="visually-hidden">&nbsp;pro&nbsp;</span><span>kg</span>
                      </div>
                  </div> 
              </div>
          </a>
          </li>
      </ul>
  </div>`

    for (let index = 0; index < resultsMarkup.length; index++) {
      const product = resultsMarkup[index];

      let cloned = new DOMParser().parseFromString(renderElement, 'text/html').body.firstChild;

      if(cloned) {
        cloned.querySelector(".feed-calc-search__item_link").innerHTML = product.title;
        cloned.querySelector(".feed-calc-price__normal").innerHTML = "Ab " + product.price;
        cloned.querySelector(".feed-calc-unit-price").innerHTML = product.unit_price;
        cloned.querySelector(".feed-calc-search__image").setAttribute("src", product.featured_media);
        cloned.querySelector(".feed-calc-search__item--link").setAttribute("data-product-id", product.id);

        if(index === 0) {
          const parent = this.querySelector(".all-search-results");
          if(parent) {
            parent.appendChild(cloned);
          }
        } else {
          const htmlBlock = this.querySelectorAll(".searchResults");
          if(htmlBlock){
            let lastElement = htmlBlock[htmlBlock.length -1];
            if(lastElement)
              lastElement.after(cloned);
          }
        }
      }
    }

    this.productLinks = this.querySelectorAll(".feed-calc-search__item--link");
    if(this.productLinks) {
      this.productLinks.forEach(link => {
        link.addEventListener('click', this.onProductClick.bind(this));
      });
    }

    this.open();
  }

  // open search results
  open() {
    this.FeedCalcSearchResults.style.display = "block";
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  // close search results
  close() {
    this.FeedCalcSearchResults.style.display = 'none';
    this.cleanSearchResults();
    this.isOpen = false;
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-activedescendant', '');
    this.input.setAttribute('aria-expanded', false);
    this.FeedCalcSearchResults.removeAttribute('style');
  }

  // delete search results on close, rendered newly if input changes
  cleanSearchResults() {
    const children = this.querySelectorAll(".searchResults");
    children.forEach((child, index) => {child.remove()});
  }
}

customElements.define('feed-calc-search', FeedCalcSearch);
